/** O que a pessoa le quando a correcao falha: a mensagem da API, ou o texto da tela. */
export function apiErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof Error && error.message.trim() !== '') {
    return error.message;
  }
  return fallback;
}

/** O `ControlledSelect` devolve string ou lista; o filtro de celula e de um valor so. */
export function singleSelectValue(value: string | Array<string>): string {
  if (Array.isArray(value)) {
    return value[0] ?? '';
  }
  return value;
}

/**
 * Os filtros da conferencia, que sao a propria barra de endereco: um link ja abre
 * filtrado. `dia` e o periodo sao exclusivos, e e por isso que escolher um limpa o
 * outro (a API tambem da a vez ao periodo quando os dois chegam).
 */
export interface ILancadosFilters {
  dia: string;
  diaDe: string;
  diaAte: string;
  celula: string;
}

/** As chaves da URL, que sao tambem o que "limpar filtros" tira do link. */
export const LANCADOS_FILTER_KEYS = ['dia', 'diaDe', 'diaAte', 'celula'] as const;

/** As fichas da barra: um dia, um periodo e a celula. As duas datas se excluem. */
export const LANCADOS_DIA_FIELD = 'dia';
export const LANCADOS_PERIODO_FIELD = 'periodo';
export const LANCADOS_CELULA_FIELD = 'celula';

/** As chaves da URL que cada ficha ocupa: a do periodo guarda as duas pontas da janela. */
export function lancadosFilterKeysOf(key: string): Array<string> {
  return key === LANCADOS_PERIODO_FIELD ? ['diaDe', 'diaAte'] : [key];
}

/** A mesma remocao como patch, para tirar uma ficha e gravar outra numa navegacao so. */
export function lancadosClearPatch(key: string): Record<string, null> {
  return Object.fromEntries(lancadosFilterKeysOf(key).map((param) => [param, null]));
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Link escrito na mao pode trazer qualquer coisa: o que nao e data vira "sem filtro". */
function readIsoDate(raw: string): string {
  const value = raw.trim();
  return ISO_DATE.test(value) ? value : '';
}

export function parseLancadosFilters(getParam: (key: string) => string): ILancadosFilters {
  return {
    dia: readIsoDate(getParam('dia')),
    diaDe: readIsoDate(getParam('diaDe')),
    diaAte: readIsoDate(getParam('diaAte')),
    celula: getParam('celula').trim(),
  };
}

/** Periodo e qualquer uma das duas pontas: so "de" ja e tudo a partir daquele dia. */
export function isPeriodo(filters: ILancadosFilters): boolean {
  return filters.diaDe !== '' || filters.diaAte !== '';
}

/**
 * O instante de uma correcao, curto e legivel no fuso de quem le. Valor ausente
 * ou carimbo que o navegador nao entende viram vazio: a linha mostra o resto.
 */
export function formatInstante(iso: string | null): string {
  if (iso === null || iso === '') {
    return '';
  }
  const quando = new Date(iso);
  if (Number.isNaN(quando.getTime())) {
    return '';
  }
  return quando.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
